import validate from 'validate-npm-package-name';
import { Result } from './result.js';

export async function validatePackageName(name: string) {
  const result = validate(name);

  if (!result.validForNewPackages) {
    const errors = [...(result.errors ?? []), ...(result.warnings ?? [])];
    return Result.Error(errors);
  }

  return Result.Ok();
}
